import { render } from "./SalesForMonth.vue?vue&type=template&id=5dc044c6"
import script from "./SalesForMonth.vue?vue&type=script&lang=js"
export * from "./SalesForMonth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__